import {
  PanTool,
  StackScrollTool,
  WindowLevelTool,
  ZoomTool,
} from "@cornerstonejs/tools";

export const MOUSE_ASSIGNABLE_TOOL_NAMES = [
  StackScrollTool.toolName,
  WindowLevelTool.toolName,
  ZoomTool.toolName,
  PanTool.toolName,
];

export const DEFAULT_MOUSE_BUTTON_TOOL_ASSIGNMENTS = {
  primary: StackScrollTool.toolName,
  secondary: WindowLevelTool.toolName,
  auxiliary: PanTool.toolName,
};

export const MOUSE_ASSIGNMENTS_STORAGE_KEY =
  "augmento.basicViewer.mouseButtonToolAssignments";

export function normalizeMouseButtonToolAssignments(raw) {
  const out = {
    primary: DEFAULT_MOUSE_BUTTON_TOOL_ASSIGNMENTS.primary,
    secondary: DEFAULT_MOUSE_BUTTON_TOOL_ASSIGNMENTS.secondary,
    auxiliary: DEFAULT_MOUSE_BUTTON_TOOL_ASSIGNMENTS.auxiliary,
  };
  if (!raw || typeof raw !== "object") {
    return out;
  }
  ["primary", "secondary", "auxiliary"].forEach((key) => {
    if (!Object.prototype.hasOwnProperty.call(raw, key)) {
      return;
    }
    const v = raw[key];
    if (v === null || v === undefined) {
      out[key] = null;
    } else if (MOUSE_ASSIGNABLE_TOOL_NAMES.includes(v)) {
      out[key] = v;
    }
  });
  return out;
}

// VAPT: moved from localStorage to sessionStorage.
export function loadMouseButtonToolAssignments() {
  try {
    // OLD: localStorage.removeItem(MOUSE_ASSIGNMENTS_STORAGE_KEY);
    sessionStorage.removeItem(MOUSE_ASSIGNMENTS_STORAGE_KEY);
    // NEW: also drop any copy an older build left in localStorage, so it doesn't linger.
    localStorage.removeItem(MOUSE_ASSIGNMENTS_STORAGE_KEY);
  } catch {
  }
  return { ...DEFAULT_MOUSE_BUTTON_TOOL_ASSIGNMENTS };
}

export function saveMouseButtonToolAssignments(assignments) {
  try {
    // OLD: localStorage.setItem(
    // OLD:   MOUSE_ASSIGNMENTS_STORAGE_KEY,
    // OLD:   JSON.stringify(assignments)
    // OLD: );
    sessionStorage.setItem(
      MOUSE_ASSIGNMENTS_STORAGE_KEY,
      JSON.stringify(assignments)
    );
  } catch {
  }
}
